export default __webpack_public_path__ + "static/media/video.001178a6.svg";